import Bugsnag, {Event} from "@bugsnag/js";
import BugsnagPluginExpress from "@bugsnag/plugin-express";
import {serializeError} from "serialize-error";

import {consoleError} from "@pg-mono/logger";

import {bugsnagReleaseStage, buildImageTag} from "../../app/read_rp_environment_variables";
import {enabledBugsnagReleaseStages} from "./bugsnag_stages";

const BUGSNAG_SERVER_KEY = "a52130f0772b6f9cc733ebcaa934c198";

/*
 * Bugsnag installs its own uncaughtException / unhandledRejection handlers, and their default
 * implementations report through `logger`, which is switched off below - so a fatal error left
 * no usable trace in stdout. The two hooks here restore that trace without touching the process
 * lifecycle: termination stays with Bugsnag and the Elastic APM agent, exactly as before.
 */
const formatError = (err: unknown) => (err instanceof Error ? err.stack || `${err.name}: ${err.message}` : JSON.stringify(serializeError(err, {maxDepth: 5})));

const getContext = (event: Event) => event.context || "no context";

export const initServerBugsnag = () => {
    /*
     * `uncaughtExceptionMonitor` runs first and synchronously, before any listener that may end
     * the process - so the trace is always written, with no race against whoever calls
     * process.exit() first. Unlike an `uncaughtException` listener it does not count as handling
     * the error, so the default crash behaviour is preserved. Registered here, not at module
     * level: this file also ends up in the client bundle, where `process` does not exist.
     */
    process.on("uncaughtExceptionMonitor", (err) => {
        consoleError("uncaughtException - the process will now terminate", "\n", formatError(err));
    });

    Bugsnag.start({
        apiKey: BUGSNAG_SERVER_KEY,
        appVersion: buildImageTag,
        releaseStage: bugsnagReleaseStage,
        enabledReleaseStages: enabledBugsnagReleaseStages,
        plugins: [BugsnagPluginExpress],
        logger: null,
        redactedKeys: [/^password$/i],
        onUnhandledRejection: (err, event) => {
            // Bugsnag does not terminate on a rejection and neither does the APM agent handle one at all.
            consoleError("Bugsnag unhandledRejection", getContext(event), "\n", formatError(err));
        }
    });
};

export const getBugsnagExpressMiddleware = () => Bugsnag.getPlugin("express");

const isErrorType = (error: unknown): error is Error => {
    return Object.prototype.hasOwnProperty.call(error, "name") && Object.prototype.hasOwnProperty.call(error, "message");
};
export const notifyBugsnagServer = (error: unknown | Error, errorInfo: string, url?: string) => {
    const errorNormalized: Error = isErrorType(error)
        ? error
        : {
              name: "Unknown error",
              message: JSON.stringify(error)
          };

    Bugsnag.notify(errorNormalized, (event) => {
        event.addMetadata("metadata", {metaData: {errorInfo, url}});
    });

    return errorNormalized;
};
import Bugsnag, {Event} from "@bugsnag/js";
import BugsnagPluginExpress from "@bugsnag/plugin-express";
import {serializeError} from "serialize-error";

import {consoleError} from "@pg-mono/logger";

import {bugsnagReleaseStage, buildImageTag} from "../../app/read_rp_environment_variables";
import {enabledBugsnagReleaseStages} from "./bugsnag_stages";

const BUGSNAG_SERVER_KEY = "a52130f0772b6f9cc733ebcaa934c198";

/*
 * Bugsnag installs its own uncaughtException / unhandledRejection handlers, and their default
 * implementations report through `logger`, which is switched off below - so a fatal error left
 * no usable trace in stdout. The two hooks here restore that trace without touching the process
 * lifecycle: termination stays with Bugsnag and the Elastic APM agent, exactly as before.
 */
const formatError = (err: unknown) => (err instanceof Error ? err.stack || `${err.name}: ${err.message}` : JSON.stringify(serializeError(err, {maxDepth: 5})));

const getContext = (event: Event) => event.context || "no context";

export const initServerBugsnag = () => {
    /*
     * `uncaughtExceptionMonitor` runs first and synchronously, before any listener that may end
     * the process - so the trace is always written, with no race against whoever calls
     * process.exit() first. Unlike an `uncaughtException` listener it does not count as handling
     * the error, so the default crash behaviour is preserved. Registered here, not at module
     * level: this file also ends up in the client bundle, where `process` does not exist.
     */
    process.on("uncaughtExceptionMonitor", (err) => {
        consoleError("uncaughtException - the process will now terminate", "\n", formatError(err));
    });

    Bugsnag.start({
        apiKey: BUGSNAG_SERVER_KEY,
        appVersion: buildImageTag,
        releaseStage: bugsnagReleaseStage,
        enabledReleaseStages: enabledBugsnagReleaseStages,
        plugins: [BugsnagPluginExpress],
        logger: null,
        redactedKeys: [/^password$/i],
        onUnhandledRejection: (err, event) => {
            // Bugsnag does not terminate on a rejection and neither does the APM agent handle one at all.
            consoleError("Bugsnag unhandledRejection", getContext(event), "\n", formatError(err));
        }
    });
};

export const getBugsnagExpressMiddleware = () => Bugsnag.getPlugin("express");

const isErrorType = (error: unknown): error is Error => {
    return Object.prototype.hasOwnProperty.call(error, "name") && Object.prototype.hasOwnProperty.call(error, "message");
};
export const notifyBugsnagServer = (error: unknown | Error, errorInfo: string, url?: string) => {
    const errorNormalized: Error = isErrorType(error)
        ? error
        : {
              name: "Unknown error",
              message: JSON.stringify(error)
          };

    Bugsnag.notify(errorNormalized, (event) => {
        event.addMetadata("metadata", {metaData: {errorInfo, url}});
    });

    return errorNormalized;
};
